import React from 'react'
import './index.css'

export default function MyContainer( props){

    let flexDirection = props.direction === 'row' ? 'row' : 'column'
    let classes = `my-container ${flexDirection} ${props.classes ? props.classes : ''}`
    let estilo = {
        zIndex: props.zIndex ? props.zIndex : '50',
        width: props.width ? props.width : 'unset',
        maxWidth: props.maxW ? props.maxW : 'unset'
    }
    return(
        <div className={classes} style={estilo} >
            {props.children}
        </div>
    )
}